import React from "react";
import { useTranslation } from "react-i18next";
import ConfirmationPage from "src/components/StatusBackground/ConfirmationPage";
import MarkdownWithRouter from "src/components/MarkdownWithRouter";

const SuccessfulPayment = () => {
  const { t } = useTranslation();
  return (
    <ConfirmationPage title={t("successfulPayment.title")} icon="svg/Check.svg">
      <h4>{t("successfulPayment.confirmationTitle")}</h4>
      <p>{t("successfulPayment.receiptSent")}</p>
      <p>
        <strong>
          <MarkdownWithRouter>
            {t("successfulPayment.emailDelayWarning")}
          </MarkdownWithRouter>
        </strong>
      </p>
    </ConfirmationPage>
  );
};

export default SuccessfulPayment;
